export interface ProcessAutoScores {
  workflowAutomation: number;
  taskEfficiency: number;
  integration: number;
}

export interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    scores: ProcessAutoScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    text: "How do you currently handle repetitive business tasks?",
    options: [
      {
        text: "Completely manual - everything done by hand",
        scores: { workflowAutomation: 3, taskEfficiency: 3, integration: 2 },
      },
      {
        text: "Some basic tools but still mostly manual",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Partially automated with standalone tools",
        scores: { workflowAutomation: 2, taskEfficiency: 1, integration: 3 },
      },
      {
        text: "Fully automated with integrated systems",
        scores: { workflowAutomation: 0, taskEfficiency: 0, integration: 1 },
      },
    ],
  },
  {
    id: 2,
    text: "What's your biggest operational bottleneck?",
    options: [
      {
        text: "Too much time spent on manual data entry",
        scores: { workflowAutomation: 3, taskEfficiency: 2, integration: 1 },
      },
      {
        text: "Tasks getting stuck waiting for approvals",
        scores: { workflowAutomation: 2, taskEfficiency: 3, integration: 1 },
      },
      {
        text: "Disconnected systems requiring duplicate work",
        scores: { workflowAutomation: 1, taskEfficiency: 2, integration: 3 },
      },
      {
        text: "Lack of visibility into process status",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 2 },
      },
    ],
  },
  {
    id: 3,
    text: "How long does it take to complete routine business processes?",
    options: [
      {
        text: "Days to weeks due to manual steps",
        scores: { workflowAutomation: 3, taskEfficiency: 3, integration: 2 },
      },
      {
        text: "Several hours with current tools",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "About an hour with some automation",
        scores: { workflowAutomation: 1, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Minutes - processes run automatically",
        scores: { workflowAutomation: 0, taskEfficiency: 1, integration: 1 },
      },
    ],
  },
  {
    id: 4,
    text: "How do your business systems communicate with each other?",
    options: [
      {
        text: "They don't - data is manually transferred",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 3 },
      },
      {
        text: "Basic exports and imports between systems",
        scores: { workflowAutomation: 1, taskEfficiency: 1, integration: 3 },
      },
      {
        text: "Some automated connections but limited",
        scores: { workflowAutomation: 1, taskEfficiency: 1, integration: 2 },
      },
      {
        text: "Fully integrated with real-time data sync",
        scores: { workflowAutomation: 0, taskEfficiency: 0, integration: 1 },
      },
    ],
  },
  {
    id: 5,
    text: "How often do errors occur in your routine processes?",
    options: [
      {
        text: "Frequently - manual processes are error-prone",
        scores: { workflowAutomation: 3, taskEfficiency: 2, integration: 1 },
      },
      {
        text: "Occasionally - catch most but not all",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Rarely - good processes but room for improvement",
        scores: { workflowAutomation: 1, taskEfficiency: 1, integration: 1 },
      },
      {
        text: "Almost never - automated validation catches issues",
        scores: { workflowAutomation: 0, taskEfficiency: 1, integration: 1 },
      },
    ],
  },
  {
    id: 6,
    text: "How do you track and monitor your business processes?",
    options: [
      {
        text: "Spreadsheets and manual tracking",
        scores: { workflowAutomation: 3, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Basic reporting from individual systems",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 3 },
      },
      {
        text: "Dashboard but data is often out of date",
        scores: { workflowAutomation: 1, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Real-time visibility across all processes",
        scores: { workflowAutomation: 0, taskEfficiency: 1, integration: 1 },
      },
    ],
  },
  {
    id: 7,
    text: "What happens when you need to scale operations?",
    options: [
      {
        text: "We have to hire more people for manual tasks",
        scores: { workflowAutomation: 3, taskEfficiency: 3, integration: 2 },
      },
      {
        text: "Current systems struggle to keep up",
        scores: { workflowAutomation: 2, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Can scale but requires significant effort",
        scores: { workflowAutomation: 1, taskEfficiency: 2, integration: 2 },
      },
      {
        text: "Automated systems scale seamlessly",
        scores: { workflowAutomation: 0, taskEfficiency: 1, integration: 1 },
      },
    ],
  },
];
